/**
 * Helpers for rendering tag pickers grouped by their `groupId`.
 *
 * Used by MDB-only inputs (Edit Achievement, Multi-Achievement Tag editor,
 * Edit Game) so the admin can see their long tag lists organized into the
 * groups they defined in MasterDatabaseTags. Regular user surfaces never
 * import this — they keep the flat tag list.
 */

/**
 * Splits a flat tag list into an array of { id, name, tags } sections,
 * preserving the order of `groups` (admin-defined) and appending an
 * "Ungrouped" bucket at the end with everything else.
 *
 * Returns an empty array if there are no tags to show.
 */
export function buildTagSections(tags, groups) {
  if (!Array.isArray(tags) || tags.length === 0) return [];
  const safeGroups = Array.isArray(groups) ? groups : [];
  const groupIds = new Set(safeGroups.map((g) => g.id));
  const buckets = new Map(safeGroups.map((g) => [g.id, []]));
  const ungrouped = [];
  tags.forEach((t) => {
    if (t.groupId && groupIds.has(t.groupId)) {
      buckets.get(t.groupId).push(t);
    } else {
      ungrouped.push(t);
    }
  });
  const sections = safeGroups
    .map((g) => ({ id: g.id, name: g.name, tags: buckets.get(g.id) || [] }))
    .filter((s) => s.tags.length > 0);
  if (ungrouped.length > 0) {
    sections.push({ id: "__ungrouped__", name: "Ungrouped", tags: ungrouped });
  }
  return sections;
}
